import React, { useEffect, useState } from "react";
import Skycons, { SkyconsType } from "react-skycons";
import "./notifications.css";

const Notifications = () => {
  const [articles, setArticles] = useState([]);
  const [weather, setWeather] = useState(null);
  const svgProps = {
    style: { backgroundColor: "#424242" },
  };
  useEffect(() => {
    setWeather({ daily: { summary: "no weather status available" } });
  }, []);
  useEffect(() => {
    let lon, lat;
    navigator.geolocation.getCurrentPosition((position) => {
      lon = position.coords.longitude;
      lat = position.coords.latitude;
      let proxy = "https://desolate-temple-60057.herokuapp.com/";
      fetch(
        `${proxy}https://api.darksky.net/forecast/1879494e658c054e3ee8c74ae2d24b58/${lat},${lon}`
      )
        .then(function (response) {
          return response.json();
        })
        .then((response) => {
          setWeather(response);
        });
    });
  }, [navigator.geolocation]);

  return (
    <div
      className=" container row grey darken-3"
      style={{ marginTop: "23px", padding: "10px", textAlign: "center" }}
    >
      {weather && (
        <div>
          <div className="flow-text" style={{ color: "white" }}>
            {weather.daily.summary}
          </div>
          <Skycons
            color="teal"
            // type={SkyconsType.CLEAR_DAY}
            type={
              weather.currently
                ? weather.currently.icon.replace(/-/g, "_").toUpperCase()
                : SkyconsType.CLEAR_DAY
            }
            animate={true}
            size={100}
            resizeClear={true}
            {...svgProps}
          />
        </div>
      )}
    </div>
  );
};
export default Notifications;
